import { useState } from 'react';

interface CardItem {
  seq: string;
  title: string;
  description: string;
  tag: string;
  imageUrl: string;
}

const cards: CardItem[] = [
  {
    seq: 'card-01',
    title: '香蕉视频 - 综合影视平台',
    description: '片库最全的综合类视频平台，覆盖电影、电视剧、综艺、动漫全品类。每日更新频率高，4K超清画质体验出色，是新用户入门的首选平台。',
    tag: '综合推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20minimalist%20design%20with%20soft%20rounded%20geometric%20elements%20in%20coral%20and%20cream%20tones%2C%20representing%20comprehensive%20entertainment%20platform%2C%20clean%20editorial%20aesthetic%2C%20gentle%20lighting&width=600&height=450&seq=card-01&orientation=landscape',
  },
  {
    seq: 'card-02',
    title: '红桃视频 - 剧集专精平台',
    description: '以电视剧和综艺内容见长，国产剧和海外剧同步更新速度领先。界面简洁清爽，播放流畅度高，适合追剧爱好者日常使用。',
    tag: '剧集专精',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20composition%20with%20flowing%20curves%20in%20warm%20amber%20and%20terracotta%20tones%2C%20representing%20drama%20series%20platform%2C%20sophisticated%20minimal%20aesthetic%2C%20editorial%20quality%2C%20soft%20gradient%20background&width=600&height=450&seq=card-02&orientation=landscape',
  },
  {
    seq: 'card-03',
    title: '91视频 - 电影发烧友之选',
    description: '电影资源丰富度领先，拥有大量独家修复版经典影片和高分新片。分类细致，检索方便，电影爱好者不可错过的宝藏平台。',
    tag: '电影精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20art%20with%20dramatic%20warm%20lighting%20in%20coral%20and%20deep%20amber%20tones%2C%20representing%20movie%20platform%2C%20bold%20geometric%20composition%2C%20editorial%20quality%2C%20high%20contrast&width=600&height=450&seq=card-03&orientation=landscape',
  },
  {
    seq: 'card-04',
    title: '蜜桃视频 - 移动观影专家',
    description: '移动端体验最优的视频平台，播放器针对手机深度优化。内容偏重轻量娱乐，综艺、短视频和轻剧集表现突出，适合通勤和碎片时间。',
    tag: '移动优选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Playful%20abstract%20design%20with%20rounded%20shapes%20in%20soft%20coral%20and%20peach%20tones%2C%20representing%20mobile%20entertainment%2C%20modern%20clean%20aesthetic%2C%20friendly%20editorial%20style%2C%20gentle%20warm%20gradient&width=600&height=450&seq=card-04&orientation=landscape',
  },
  {
    seq: 'card-05',
    title: '平台交叉对比指南',
    description: '横向对比各大视频平台的片库规模、更新频率、画质选项和播放稳定性，根据不同观影偏好给出个性化推荐，帮你做出最合适的选择。',
    tag: '选台指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20composition%20with%20intersecting%20geometric%20lines%20in%20warm%20coral%20and%20golden%20amber%20tones%2C%20representing%20platform%20comparison%2C%20clean%20editorial%20aesthetic%2C%20balanced%20composition&width=600&height=450&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  const [imgErrors, setImgErrors] = useState<Record<string, boolean>>({});
  const handleImgError = (seq: string) => setImgErrors((prev) => ({ ...prev, [seq]: true }));

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              平台导览
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              视频平台一览
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              了解每个平台的独特优势，找到最适合你的观影入口
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cards.map((card) => (
              <div key={card.seq} className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-300 flex flex-col">
                <div className="aspect-[4/3] bg-background-200 overflow-hidden">
                  {!imgErrors[card.seq] ? (
                    <img
                      src={card.imageUrl}
                      alt={`${card.title} - 69视频平台导览`}
                      title={`69视频-${card.title}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      onError={() => handleImgError(card.seq)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-foreground-300">
                      <i className="ri-image-line text-3xl"></i>
                    </div>
                  )}
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col">
                  <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-primary-100 text-primary-700 mb-2 self-start whitespace-nowrap">
                    {card.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex-1">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}